import { RequestStatus } from "../../request";
import { CampaignChange } from "./reducer";

export const FetchCampaignsOverview = (limit?: number, offset?: number,partnerId?:number) => {
  return {
    type: "overview-request-campaigns",
    limit,
    offset,
    partnerId
  };
};

export const UpdateCampaignStatusAction = (id: string, isActive: boolean) => {
  return {
    type: "overview-update-campaign-status",
    id: id,
    isActive: isActive,
  };
};

export const UpdateCampaignStatusStateAction = (
  id: string,
  isActive: boolean
) => {
  return {
    type: "overview-deactivate-campaign",
    id: id,
    isActive: isActive,
  };
};

export const UpdateCampaignChangesRequestStateAction = (
  requestState: RequestStatus
) => {
  return {
    type: "campaign-changes-update-request-state",
    requestState: requestState,
  };
};

export const UpdateCampaignChanges = ({
  campaignChanges,
  totalCampaignChangeCount,
}: {
  campaignChanges: CampaignChange[];
  totalCampaignChangeCount: number;
}) => {
  return {
    type: "campaign-changes-update-state",
    campaignChanges,
    totalCampaignChangeCount,
  };
};

export const UpdateOverviewDateRanges = (startDate: Date, endDate: Date) => {
  return {
    type: "overview-update-date-ranges",
    startDate: startDate,
    endDate: endDate,
  };
};
